import { defineComponent as _defineComponent } from 'vue'
import { ref } from "@nuxtjs/composition-api";
import Sorter from "./sorter.vue";

interface Option {
  value: string;
  label: string;
}

type SortValue = false | "asc" | "desc";


export default /*#__PURE__*/_defineComponent({
  __name: 'sort-list',
  props: {
    options: { default: () => [] },
    extraQuery: null,
    fieldName: { default: 'order_field' },
    orderName: null,
    field: null,
    value: null
  },
  emits: ["input", "update:field", "change"],
  setup(__props: any, { emit }: { emit: ({
  (name: "input", value: SortValue): void;
  (name: "update:field", value: string): void;
  (name: "change"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { options: Array<Option>, extraQuery?: Record<string, any>, fieldName: string, orderName?: string, field: string, value: "asc" | "desc" }





const onSort = (option: Option, sort: SortValue) => {
  emit("update:field", option.value);
  emit("input", sort);

  emit("change");
};

return { __sfc: true,props, emit, onSort, Sorter }
}

})